import { searchRegistry } from "../../platform/search/register/search-registry";
import { NotebookPen, Key } from "lucide-react";

//contains links to files which are not part of nav items
searchRegistry.register([
    {
        id: "notes",
        title: "My Notes",
        description: "Manage Notes",
        route: "/my-notes",
        category: "Administration",
        permissions: ["ADMIN", "EMPLOYEE", "USER"],
        tags: ["notes"],
        icon: NotebookPen,
        type: 'result'
    },
    {
        id: "change.password",
        title: "Change User Credential",
        description: "Manage Employees",
        route: "/user/reset-password",
        category: "Administration",
        permissions: ["ADMIN", "EMPLOYEE", "USER"],
        tags: ["password", "change"],
        icon: Key,
        type: 'result'
    },
])
